import { cn } from '@client/lib';
import { ASSET_OPTIONS, AssetSelectionButton } from './AssetSelectionGrid';

interface PriorityAssetSelectorProps {
  selectedAssets: LtcFinancialPlanningAssetType[];
  priorityAssets: LtcFinancialPlanningAssetType[];
  onTogglePriority: (assetType: LtcFinancialPlanningAssetType) => void;
  className?: string;
}

export function PriorityAssetSelector({
  selectedAssets,
  priorityAssets,
  onTogglePriority,
  className,
}: PriorityAssetSelectorProps) {
  const availableAssets = ASSET_OPTIONS.filter(asset => selectedAssets.includes(asset.type));

  return (
    <div className={cn('grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3', className)}>
      {availableAssets.map(asset => {
        const isPriority = priorityAssets.includes(asset.type);
        return (
          <AssetSelectionButton
            asset={asset}
            isSelected={isPriority}
            onToggleAsset={onTogglePriority}
          />
        );
      })}
    </div>
  );
}

